/**
 * QuizResultPage - Shows quiz results with score, ranking, and actions
 * Refactored to use smaller components
 */
import { useLocation, useNavigate } from 'react-router-dom';
import { getUserId } from '@/lib/api';
import ScoreCard from '@/components/result/ScoreCard';
import RankingCard from '@/components/result/RankingCard';
import UnlockStatus from '@/components/result/UnlockStatus';
import ResultActions from '@/components/result/ResultActions';
import NicknameBox from '@/components/NicknameBox';
import Leaderboard from '@/components/Leaderboard';

export default function QuizResultPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const result = location.state?.result;
  const runId = result?.runId || location.state?.runId;

  if (!result) { 
    navigate('/'); 
    return null; 
  }

  const { 
    correctCount, totalQuestions, percentCorrect, totalTimeMs, rankingScore,
    rankGlobal, totalGlobal, rankMonth, totalMonth, unlockStatus, level, runType 
  } = result;

  const nextLevel = level === 'anfaenger' ? 'fortgeschritten' : level === 'fortgeschritten' ? 'experte' : null;
  const isUnlocked = unlockStatus?.unlocked;
  const isFinalScreen = level === 'experte' || (nextLevel && !isUnlocked);

  return (
    <div className="flex-1 flex items-center justify-center px-4 py-4 sm:py-6" data-testid="quiz-result-page">
      <div className="animate-fade-up max-w-lg w-full">
        <ScoreCard
          correctCount={correctCount}
          totalQuestions={totalQuestions}
          percentCorrect={percentCorrect}
          totalTimeMs={totalTimeMs}
          level={level}
        />

        {runType === 'normal' && (
          <RankingCard
            rankGlobal={rankGlobal}
            totalGlobal={totalGlobal}
            rankMonth={rankMonth}
            totalMonth={totalMonth}
            rankingScore={rankingScore}
          />
        )}

        {runType === 'normal' && <NicknameBox />}

        <UnlockStatus nextLevel={nextLevel} unlockStatus={unlockStatus} />

        <ResultActions
          runId={runId}
          level={level}
          result={result}
          nextLevel={nextLevel}
          isUnlocked={isUnlocked}
          isFinalScreen={isFinalScreen}
        />

        {isFinalScreen && runType === 'normal' && (
          <Leaderboard currentUserId={getUserId()} />
        )}
      </div>
    </div>
  );
}
